import { useEffect, useState, useContext } from "react";
import axios from "axios";
import MyContext from "../../../../MyContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OtherPaymentMethod = ({ userID }) => {
  const { baseUrl, config } = useContext(MyContext);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentMethodsList, setPaymentMethodsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);

  const getPaymentMethods = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/getReceiptData`,
        { userid: userID },
        config
      );
      if (response.data.responseCode === "00") {
        const methods = response.data.paymentMethods || [];
        setPaymentMethodsList(methods);
      }
    } catch (error) {
      console.error("Error fetching payment methods", error);
      toast.error("Error fetching payment methods");
    }
  };

  const addPaymentMethod = async () => {
    if (!paymentMethod.trim()) return toast.warning("Please enter a payment method");
    setAddLoading(true);
    try {
      const payload = {
        userid: userID,
        paymentMethod: paymentMethod.trim(),
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/Pos/addPaymentMethodOption`,
        payload,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success("Payment method added successfully");
        setPaymentMethod("");
        getPaymentMethods();
      } else {
        toast.error(response.data.responseMessage || "Failed to add payment method");
      }
    } catch (error) {
      console.error("Error adding payment method", error);
      toast.error("Error adding payment method");
    } finally {
      setAddLoading(false);
    }
  };

  const deletePaymentMethod = async (methodId) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/Pos/deletePaymentMethodOption`,
        {
          userid: userID,
          paymentMethodId: methodId,
        },
        config
      );

      if (response.data.responseCode === "00") {
        toast.success("Payment method deleted successfully");
        getPaymentMethods();
      } else {
        toast.error(response.data.responseMessage || "Failed to delete payment method");
      }
    } catch (error) {
      console.error("Error deleting payment method", error);
      toast.error("Error deleting payment method");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPaymentMethods();
  }, []);

  return (
    <div className="row">
      <ToastContainer />
      <div className="col-12">
         {/* Add new payment method */}
        <div className="p-4 bg-light border-0 mb-4 rounded-4">
          <h5 className="fw-semibold text-success mb-4">Add Payment Method</h5>
          <div className="row g-4 align-items-end">
            <div className="col-md-6">
              <label className="form-label">Payment Method</label>
              <input
                type="text"
                className="form-control"
                placeholder="e.g., Paytm, PhonePe"
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
                disabled={addLoading}
              />
            </div>
            <div className="col-md-3">
              <button
                className="btn btn-success"
                onClick={addPaymentMethod}
                disabled={addLoading}
              >
                {addLoading ? "Adding..." : "Add Method"}
              </button>
            </div>
          </div>
        </div>
        {/* Existing payment methods */}
        {paymentMethodsList.length > 0 &&
          paymentMethodsList.map((method, index) => (
            <div key={index} className="col">
              <div className="p-4 bg-white w-100 border rounded-4 mb-3">
                <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                  <h5 className="fw-semibold text-success">
                    {method.method}
                  </h5>
                  <div>
                    <button
                      className="btn btn-danger"
                      onClick={() => deletePaymentMethod(method.id)}
                      disabled={loading}
                    >
                      Remove
                    </button>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Payment Method:</span>
                  <span className="fw-medium text-dark">
                    {method.method}
                  </span>
                </div>
              </div>
            </div>
          ))}

       
      </div>
    </div>
  );
};

export default OtherPaymentMethod;
